// extracted by mini-css-extract-plugin
export default {"app":"global_app__XQdGY","bounce":"global_bounce__BxQOY"};